// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bb4bcec3","453":"37381017","455":"067c8054","977":"8cfca1c2"}[chunkId] + ".chunk.js";
};